import { ReactRenderer } from "@tiptap/react";
import TiptapSuggestion from "@tiptap/suggestion";
import { PluginKey } from "prosemirror-state";
import {
  anchorToSelection,
  updateFloatingPosition
} from "./../../editor-common/Utils/floating-ui-utils.js";
import MentionList from "./MentionList.js";
const Suggestion = (editor, {
  mentionTrigger,
  getMentions,
  visibleItemsBeforeOverflow,
  handleDropdownOpen,
  handleDropdownClose,
  supportWhitespace = true,
  zIndex
}) => {
  const shouldEndMentioningProcess = (query, items) => {
    const names = items.map((item) => item.name.toLowerCase());
    return !names.some((name) => name.includes(query.toLowerCase()));
  };
  return TiptapSuggestion({
    editor,
    char: mentionTrigger,
    allowSpaces: supportWhitespace,
    pluginKey: new PluginKey("mention"),
    command: ({
      editor: editor2,
      range,
      props
    }) => {
      const { name, slug, id } = props;
      editor2.chain().focus().insertMention({ name, slug, id }, range).run;
    },
    items: async ({ query }) => {
      const mentions = await getMentions(query);
      return mentions.map((mention) => ({
        name: mention.name,
        slug: mention.slug,
        avatar: mention.avatar,
        id: mention.id
      })).slice(0, visibleItemsBeforeOverflow);
    },
    render: () => {
      let cleanup;
      let renderer;
      return {
        onStart: (props) => {
          renderer = new ReactRenderer(MentionList, {
            editor,
            props
          });
          const element = renderer.element;
          element.setAttribute("dir", "");
          element.style.position = "absolute";
          const portal = document.querySelector("[data-hook=ricos-portal]") ?? document.body;
          portal.appendChild(element);
          cleanup = anchorToSelection(editor, renderer, zIndex);
          if (handleDropdownOpen) {
            handleDropdownOpen();
          } else {
            updateFloatingPosition(props.editor, element, zIndex);
          }
        },
        onUpdate(props) {
          renderer.updateProps(props);
          if (!handleDropdownOpen) {
            updateFloatingPosition(props.editor, renderer.element, zIndex);
          }
        },
        onKeyDown(props) {
          if (props.event.key === "Escape") {
            this.onExit?.();
            return true;
          }
          const { items, query } = renderer.props;
          if (["Enter", "Tab"].includes(props.event.key) && shouldEndMentioningProcess(query, items)) {
            this.onExit?.();
            return false;
          }
          if (!handleDropdownClose) {
            return renderer.ref?.onKeyDown?.(props) ?? false;
          }
          return false;
        },
        onExit() {
          renderer?.destroy?.();
          cleanup?.();
          if (handleDropdownClose) {
            handleDropdownClose();
          } else {
            renderer.element.remove();
          }
        }
      };
    }
  });
};
export {
  Suggestion
};
//# sourceMappingURL=suggestion.js.map
